import { render, staticRenderFns } from "./SingleNumberFilterComp.vue?vue&type=template&id=8e635818&"
import script from "./SingleNumberFilterComp.vue?vue&type=script&lang=js&"
export * from "./SingleNumberFilterComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports